/**
*  @class
*  @function HeaderScroll
*/
if (!customElements.get('header-scroll')) {
  class HeaderScroll extends HTMLElement {
    constructor() {
      super();
      this.lastScrollTop = 0;
      this.scrollThreshold = 100; // Threshold before hiding/showing menu
      this.isScrolling = false;
      this.scrollTimeout = null;
      this.isVisible = true;
    }

    connectedCallback() {
      // Set header height CSS variable
      const headerHeight = this.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

      // Add initial class
      this.classList.add('menu-visible');

      // Add scroll event listener
      window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });

      // Update header height on resize
      window.addEventListener('resize', () => {
        const newHeight = this.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${newHeight}px`);
      }, { passive: true });
    }

    handleScroll() {
      if (this.scrollTimeout) {
        window.cancelAnimationFrame(this.scrollTimeout);
      }

      this.scrollTimeout = window.requestAnimationFrame(() => {
        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollingDown = currentScrollTop > this.lastScrollTop;
        const scrollingUp = currentScrollTop < this.lastScrollTop;

        // Only trigger if we've scrolled past the threshold
        if (currentScrollTop > this.scrollThreshold) {
          if (scrollingDown && this.isVisible) {
            // Scrolling down - hide menu
            this.isVisible = false;
            this.classList.remove('menu-visible');
            this.classList.add('menu-hidden');
          } else if (scrollingUp && !this.isVisible) {
            // Scrolling up - show menu
            this.isVisible = true;
            this.classList.remove('menu-hidden');
            this.classList.add('menu-visible');
          }
        } else if (currentScrollTop <= this.scrollThreshold && !this.isVisible) {
          // At the top - always show menu
          this.isVisible = true;
          this.classList.remove('menu-hidden');
          this.classList.add('menu-visible');
        }

        this.lastScrollTop = currentScrollTop;
      });
    }
  }
  customElements.define('header-scroll', HeaderScroll);
} 